import {FireOutlined} from '@ant-design/icons'
import {Avatar} from 'antd'
import classNames from 'classnames'
import _ from 'lodash'
import React, {useContext} from 'react'
import {BiConversation, BiSolidBible, BiSolidChurch} from 'react-icons/bi'
import {
    BsCalendar2DateFill,
    BsCalendar2Week,
    BsCalendar3,
    BsPersonCircle,
    BsPersonFill,
    BsRadioactive,
} from 'react-icons/bs'
import {FaHeadphonesAlt} from 'react-icons/fa'
import {ImFileText2, ImFileWord} from 'react-icons/im'
import {IoChatbubblesOutline, IoGameControllerOutline, IoNewspaperOutline, IoSpeedometerOutline} from 'react-icons/io5'
import {
    PiBooks,
    PiChalkboardSimple,
    PiGearSix,
    PiHandHeart,
    PiMusicNotesFill,
    PiTextAa,
    PiUsersThree,
    PiWarningDuotone
} from 'react-icons/pi'
import {RiAppsLine, RiHashtag, RiSignalTowerFill, RiUser3Fill,} from 'react-icons/ri'
import {SearchTypes} from 'views/Search/SearchProvider'
import {getFullAvatarUrl} from '../apis/model/base'
import {WorkSpaceActions} from '../views/Workspace/Workspace'
import {ChannelIcon} from './icons/ChannelIcon'
import {LawSvg} from './Svgs/LawSvg'
import {GiOrganigram, GiPathDistance} from "react-icons/gi";
import {LayoutContext} from "./layouts/Default/LayoutContext";
import {SaintsFillSvg} from "./Svgs/SaintsPlaceholder";
import {PrelatesFillSvg} from "./Svgs/PrelatesPlaceholder";
import {LocalContext} from "../modules/local/LocalContext";
import {ReligiousFillSvg} from "./Svgs/ReligiousIconSvg";
import {DiocesesFillSvg} from "./Svgs/DiocesesIconSvg";
import {BibleBookFillSvg} from "./Svgs/BibleBookSvg";
import {ExamOutlineSvg} from "./Svgs/ExamSvg";
import {VaticanIISvg} from "./Svgs/VaticanIISvg";
import {CanonLawSvg} from "./Svgs/CanonLawSvg";
import {CateChismSvg} from "./Svgs/CateChismSvg";
import {YellowPagesSvg} from "./Svgs/YellowPagesSvg";
import {MissalsSvg} from "./Svgs/MissalsSvg";
import {DivineWordSvg} from "./Svgs/DivineWordSvg";
import {CatholicHouseholdSvg} from "./Svgs/CatholicHouseholdSvg";
import {parseDayjs} from "../helpers/datetimeHelpers";
import {FaServer, FaUserTie} from "react-icons/fa6";
import {MassTimeFillSvg} from "./Svgs/MassTimeIconSvg";
import {LuRadioTower} from "react-icons/lu";
import {ShoppingIconSvg} from "./Svgs/ShoppingIconSvg";
import {EvangelizationSvg} from "./Svgs/EvangelizationSvg";
import {HiOutlineMegaphone} from "react-icons/hi2";

export const CalendarIcon = ({time, className, size}) => {
    const {lang} = useContext(LocalContext)
    const {isSm} = useContext(LayoutContext)
    const dt = parseDayjs(time)
    var month = dt.format('MMM')
    var day = dt.format('DD')

    return (
        <div
            style={{width: size ? size : (isSm ? 46 : 50), height: size ? size : (isSm ? 46 : 50)}}
            className={classNames("flex flex-col gap-1 flex-center rounded-xs bg-primary text-white", className)}>
            <span
                style={{fontSize: isSm ? 10 : 12, marginBottom: isSm ? 1 : 2}}
                className="flex flex-center leading-snug tracking-wide font-medium">
                {month}
            </span>
            <div
                style={{fontSize: 11, width: isSm ? '60%' : '70%', borderRadius: 3}}
                className="flex flex-center text-color-000 bg-white font-bold leading-snug mx-auto">
                {day}
            </div>
        </div>
    )
}

export default function AppIcon({item}) {
    if (!!!item || !!!item._type) return null
    switch (item._type) {
        case 'channel':
            return (
                <Avatar
                    size={28}
                    className="flex flex-center background-200 rounded-md"
                    icon={<ChannelIcon fill="text-color-300"/>}
                />
            )
        case 'event':
            return (
                <div
                    className="flex items-center justify-center"
                    style={{
                        minWidth: '2rem',
                        minHeight: '2rem',
                        width: '2rem',
                        height: '2rem',
                    }}>
                    <CalendarIcon time={item.time_open}/>
                </div>
            )
        case 'article':
            return (
                <div
                    className="flex items-center justify-center"
                    style={{
                        minWidth: '2rem',
                        minHeight: '2rem',
                        width: '2rem',
                        height: '2rem',
                    }}>
                    <IoNewspaperOutline/>
                </div>
            )
        case 'document':
            return (
                <div className="flex items-center justify-center">
                    <ImFileText2 className="text-color-300"/>
                </div>
            )
        case 'ask':
        case 'post':
            return (
                <div
                    className="flex items-center justify-center"
                    style={{
                        minWidth: '2rem',
                        minHeight: '2rem',
                        width: '2rem',
                        height: '2rem',
                    }}>
                    <BiConversation/>
                </div>
            )
        case 'user':
            return (
                <Avatar
                    size={30}
                    className="flex flex-center background-200"
                    src={getFullAvatarUrl(item)}
                    icon={
                        <RiUser3Fill
                            size={16}
                            className="text-color-400"
                        />
                    }
                />
            )
        case 'organization':
            return (
                <Avatar
                    size={30}
                    className="flex flex-center background-200"
                    src={getFullAvatarUrl(item)}
                    icon={
                        <BiSolidChurch
                            size={16}
                            className="text-color-400"
                        />
                    }
                />
            )
        case 'keyword':
            return (
                <Avatar
                    className="flex flex-center background-100"
                    src={getFullAvatarUrl(item)}
                    icon={<ImFileWord className="text-color-300"/>}
                />
            )
        default:
            return (
                <div
                    className="flex items-center justify-center"
                    style={{
                        minWidth: '2rem',
                        minHeight: '2rem',
                        width: '2rem',
                        height: '2rem',
                    }}>
                    <Avatar
                        shape="square"
                        className="background-200"
                        src={getFullAvatarUrl(item)}
                        icon={<FireOutlined className="text-3xl justify-start"/>}
                    />
                </div>
            )
    }
}

export const SearchGroupIcon = ({
                                    size = 20,
                                    style,
                                    className = "text-primary",
                                    type = SearchTypes.ALL,
                                }) => {
    if (_.isEmpty(type)) return null
    switch (type) {
        case SearchTypes.ORGANIZATION:
            return (
                <BiSolidChurch
                    size={size}
                    className={className}
                />
            )
        case "codi_document":
            return (
                <PiBooks
                    size={size}
                    width={size}
                    height={size}
                    className={className}
                />
            )
        case SearchTypes.CODI_DOCUMENT:
            return (
                <PiBooks
                    size={size}
                    width={size}
                    height={size}
                    className={className}
                />
            )
        case "codi_document_row":
        case SearchTypes.CODI_DOCUMENT_ROW:
            return (
                <BibleBookFillSvg
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.DOCUMENT:
            return (
                <LawSvg
                    size={size}
                    width={size}
                    height={size}
                    className={className}
                />
            )
        case SearchTypes.ASK:
            return (
                <IoChatbubblesOutline
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.KEYWORD:
            return (
                <RiHashtag
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.ARTICLE:
            return (
                <IoNewspaperOutline
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.EVENT:
            return (
                <BsCalendar2DateFill
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.PILGRIMAGE:
            return (
                <GiPathDistance
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.EVANGELIZATION:
            return (
                <EvangelizationSvg
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.EXAMINATION:
            return (
                <ExamOutlineSvg
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.CHANNEL:
            return (
                <RiSignalTowerFill
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.PRODUCT:
            return (
                <ShoppingIconSvg
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.USER:
            return (
                <BsPersonFill
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.LITURGY:
            return (
                <BsCalendar2Week
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.CHURCHES:
            return (
                <MassTimeFillSvg
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.DIVINE_WORD:
            return (
                <DivineWordSvg
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.BIBLES:
            return (
                <BiSolidBible
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.PROFILES:
            return (
                <FaUserTie
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.SAINTS:
            return (
                <SaintsFillSvg
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.PRELATES:
            return (
                <PrelatesFillSvg
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.DIOCESES:
            return (
                <DiocesesFillSvg
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.RELIGIOUS_ORDERS:
            return (
                <ReligiousFillSvg
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.FEEDBACK:
            return (
                <PiWarningDuotone
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.DEFINITION:
            return (
                <PiTextAa
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.ECCLESIASTIC:
            return (
                <CanonLawSvg
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.VATICAN_II:
            return (
                <VaticanIISvg
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.CANON_LAW:
            return (
                <CanonLawSvg
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.CATECHISM:
            return (
                <CateChismSvg
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.YELLOW_PAGE:
            return (
                <YellowPagesSvg
                    size={size}
                    className={className}
                />
            )
        case SearchTypes.MISSALS:
            return (
                <MissalsSvg
                    size={size}
                    className={className}
                />
            )

        // Platform
        case 'organizations':
            return (
                <BiSolidChurch
                    size={size}
                    className={className}
                />
            )
        case 'accounts':
            return (
                <BsPersonCircle
                    size={size}
                    className={className}
                />
            )
        case 'resources':
            return (
                <FaServer
                    size={size}
                    className={className}
                />
            )
        case 'press-center':
            return (
                <LuRadioTower
                    size={size}
                    className={className}
                />
            )

        //  Workspace
        case WorkSpaceActions.EVENT:
            return (
                <BsCalendar3
                    size={size}
                    style={style}
                    className={className}
                />
            )
        case WorkSpaceActions.STRUCTURE:
            return (
                <GiOrganigram
                    size={size}
                    style={style}
                    className={className}
                />
            )
        case WorkSpaceActions.REFERENCE_DATA:
            return (
                <BsRadioactive
                    size={size}
                    style={style}
                    className={className}
                />
            )
        case WorkSpaceActions.MUSIC:
            return (
                <PiMusicNotesFill
                    size={size}
                    style={style}
                    className={className}
                />
            )
        case WorkSpaceActions.SALES:
            return (
                <FaHeadphonesAlt
                    size={size}
                    style={style}
                    className={className}
                />
            )
        //  Workspace - active
        case WorkSpaceActions.HOME:
            return (
                <IoSpeedometerOutline
                    size={size}
                    style={style}
                    className={className}
                />
            )
        case WorkSpaceActions.COMMUNICATIONS:
            return (
                <HiOutlineMegaphone
                    size={size}
                    style={style}
                    className={className}
                />
            )
        case WorkSpaceActions.MEMBER:
            return (
                <PiUsersThree
                    size={size}
                    style={style}
                    className={className}
                />
            )
        case WorkSpaceActions.COURSE:
            return (
                <PiChalkboardSimple
                    size={size}
                    style={style}
                    className={className}
                />
            )
        case WorkSpaceActions.SETTING:
            return (
                <PiGearSix
                    size={size}
                    style={style}
                    className={className}
                />
            )
        case WorkSpaceActions.FAMILY_BOOK:
            return (
                <CatholicHouseholdSvg
                    size={size}
                    style={style}
                    className={className}
                />
            )
        case WorkSpaceActions.FINANCE:
            return (
                <PiHandHeart
                    size={size}
                    style={style}
                    className={className}
                />
            )
        case WorkSpaceActions.GAMES:
            return (
                <IoGameControllerOutline
                    size={size}
                    style={style}
                    className={className}
                />
            )
        case WorkSpaceActions.PRODUCT:
            return (
                <ShoppingIconSvg
                    size={size}
                    style={style}
                    className={className}
                />
            )
        default:
            return (
                <RiAppsLine
                    size={size}
                    style={style}
                    className={className}
                />
            )
    }
}
